// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.isClickStyle[data-v-ce3f0aaa] {\n  cursor: pointer;\n  color: #409eff;\n}\n", ""]);
// Exports
module.exports = exports;
